module.exports = __webpack_public_path__ + "img/Speaker=Malte Lauterbach.c553c1db.png";